// @ts-nocheck
import React, { ComponentType } from "react";

export type HookPropsInjector<P, H> = (props: Omit<P, keyof H>) => H;

function withHookProps<P, H>(Component: ComponentType<P>, fn: (props: any) => H) {
    return function WrapperComponent(props: Omit<P, keyof H>) {
        return <Component {...(props as P)} {...(fn(props) as any)} />;
    };
}

export default withHookProps;
